export default "__VITE_ASSET__BLbUsrr8__"